import { Component } from 'react';
import { collection, query, where, getDocs, limit, startAfter, orderBy } from 'firebase/firestore';
import { db } from '../config/fbConfig';
import { Link } from 'react-router-dom';

export default class Search extends Component {

  constructor(props) {
    super(props);
    this.state = {
      results: [],
      lastVisible: null,
      loading: true,
      page: 1,
      hasNextPage: true
    };
  }

  componentDidMount() {
    this.fetchResults();
  }

  getOppositeGender = (gender) => {
    if (gender.toLowerCase() === 'male') return 'Female';
    if (gender.toLowerCase() === 'female') return 'Male';
    return '';
  };

  fetchResults = async (next = false) => {
    const { userData } = this.props;
    const genderToSearch = this.getOppositeGender(userData.Gender);

    let q = query(
      collection(db, 'Member_Profiles'),
      where('Gender', '==', genderToSearch),
      orderBy('User_Id', 'desc'),
      limit(10)
    );

    if (next && this.state.lastVisible) {
      q = query(q, startAfter(this.state.lastVisible));
    }

    const snapshot = await getDocs(q);
    const docs = snapshot.docs;

    const results = docs.slice(0, 9).map((doc) => doc.data()); // show only 9
    const lastVisible = results.length > 0 ? docs[results.length - 1] : null;
    const hasMore = docs.length === 10; // 10th doc exists = more pages

    this.setState((prevState) => ({
      results: next ? [...prevState.results, ...results] : results,
      lastVisible,
      loading: false,
      hasNextPage: hasMore,
      page: next ? prevState.page + 1 : 1,
    }));
  };

  render() {
    const { results, loading, hasNextPage } = this.state;

    return (
      <div className="container mt-3 mb-5">
        {loading ? (
          <p>Loading profiles...</p>
        ) : (
          <div className="row">
            {results.map((user, index) => (
              <div key={index} className="col-md-4 col-sm-6 mb-4">
                <div className="profile-card shadow-sm p-4 text-center">
                  <img
                    src={`https://varenyamatrimonial.com/profile_images/${user.User_Id}_1.webp`}
                    className="profile-img mb-3"
                    alt={user.Name}
                  />
                  <h6 className="mb-1 text-dark">{user.Name}</h6>
                  <small className="text-muted">({user.User_Id})</small>
                  <p className="text-secondary mt-2 mb-2 small">
                    <b>DOB : </b>{user.DOB} | <b>Height : </b>{user.Height} cm
                  </p>
                  <Link
                    to={`/user/${user.User_Id}`}
                    className="btn btn-sm btn-outline-maroon rounded-pill"
                  >
                    View Details
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Pagination Button */}
        {hasNextPage && (
          <div className="text-center">
            <button className="load-more-btn" onClick={() => this.fetchResults(true)}>
              Load More
            </button>
          </div>
        )}

      </div>
    );
  }
}
